import GLMappingRoutes from './route-types.js'

const moduleId = 'A069'

const GLMappingView = () => import('./GLMappingView')

export default [
  {
    path: GLMappingRoutes.GLMappingView.path,
    name: GLMappingRoutes.GLMappingView.name,
    component: GLMappingView,
    meta: {
      id: moduleId,
      route: 'listing',
      title: 'G/L Mapping',
      name: 'GLMapping'
    }
  }
]
